import React from "react";
import { Route, Routes } from "react-router-dom";

import MessageTemplates from "@/components/screens/MessageTemplates";
import MessageTemplateFormPage from "@/components/screens/MessageTemplateFormPage";
import { MESSAGE_TEMPLATE_MESSAGES } from "@/messages/message-template/message-template.messages";

const MessageTemplatesPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<MessageTemplates messages={MESSAGE_TEMPLATE_MESSAGES} />} />
      <Route
        path="/update/:templateId/:lang"
        element={<MessageTemplateFormPage messages={MESSAGE_TEMPLATE_MESSAGES} />}
      />
      <Route path="/" element={<MessageTemplates messages={MESSAGE_TEMPLATE_MESSAGES} />} />
    </Routes>
  );
};

export default MessageTemplatesPage;
